eval("define(\'oroui/js/app/models/base/model\',[\n    \'chaplin\'\n], function(Chaplin) {\n    \'use strict\';\n\n    var BaseModel;\n\n    BaseModel = Chaplin.Model.extend({\n\n    });\n\n    return BaseModel;\n});\n\n//# sourceURL=/oroui/js/app/models/base/model.js");

